<script setup>

import UtilObject from "@/utils/UtilObject";
import { defineProps, defineEmits, computed, watch, ref} from "vue";
import ERP from "@apiV2/ERP.mjs"
import View from "@apiV2/View.mjs";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "controlesDesativados",
    "modalStatus",
    "dadoOriginal",
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraRecarregaDados",
    "update:alteraModalStatus",
    "update:alteraModalLoading"
]);

//==================================================================//
//===================== Contas Financeiras =========================//
//==================================================================//

const contasFinanceiras = ref([]);

//==================================================================//
//================= Contas Financeiras Loaded ======================//
//==================================================================//

const contasFinanceirasLoaded = ref(false);

//==================================================================//
//============================= Dado ===============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//========================= Adiantamento ===========================//
//==================================================================//

const adiantamento = ref({});

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//======================= Altera Modal Status ======================//
//==================================================================//

const alteraRecarregaDados = (update) =>{

    emits('update:alteraRecarregaDados',update);

};

//==================================================================//
//======================= Altera Modal Status ======================//
//==================================================================//

const alteraModalStatus = (update) =>{

    emits('update:alteraModalStatus',update);

};

//==================================================================//
//==================== Altera Modal Loading ========================//
//==================================================================//

const alteraModalLoading = (update) =>{

    emits('update:alteraModalLoading',update);

    alteraControlesDesativados(update);

};

//==================================================================//
//======================== Modal Visivel ===========================//
//==================================================================//

const modalVisivel = computed(()=>{

    if(props.modalStatus == false){
        return false;
    }

    if(contasFinanceirasLoaded.value == false){
        return false;
    }

    return true;

});

//==================================================================//
//========================== Altera Dado ===========================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value,update);

};

//==================================================================//
//========================== Altera Dado ===========================//
//==================================================================//

const alteraAdiantamento = (update = {})=>{

    adiantamento.value = UtilObject.merge(adiantamento.value,update);

};

//==================================================================//
//================== Load Contas Financeiras =======================//
//==================================================================//

const loadContasFinanceiras = async ()=>{

    if(contasFinanceirasLoaded.value == true){
        return;
    }

    const contasFinanceirasResponse = await ERP.getManyWithView(View.CONTAS_A_RECEBER_CONTAS_FINANCEIRAS);
    contasFinanceiras.value = contasFinanceirasResponse.data;

    contasFinanceirasLoaded.value = true;

};

//==================================================================//
//========================= Prepara Dado ===========================//
//==================================================================//

const preparaDado = (dado = {})=>{

    let parcelas = dado?.parcelas?.reduce((acc,parcela)=>{

        if(
            parcela?.tipoOculto == "NF" || 
            parcela?.valorParaReceber == 0
        ){
            return acc;
        }

        acc.push({
            id: parcela?.id,
            codigo: parcela?.codigo,
            tipoOculto: parcela?.tipoOculto,
            tipo: parcela?.tipo,
            descricao: parcela?.descricao,
            valorOriginal: parcela?.parcelaValor,
            valorRecebido: parcela?.valorRecebido,
            valorParaReceber: parcela?.valorParaReceber,
        })

        return acc;

    },[]);

    dado = {
        id: dado?.id || "",
        codigo: dado?.codigo || "",
        parcelas: parcelas || [],
    };

    alteraDado(dado);

};

//==================================================================//
//===================== Prepara Adiantamento =======================//
//==================================================================//

const preparaAdiantamento = ()=>{

    alteraAdiantamento({
        jobParcela: {},
        contaFinanceira:{},
        valorOriginal:0,
    });

};


//==================================================================//
//===================== Limpa Conta Financeira =====================//
//==================================================================//

const limpaContaFinanceira = () =>{

    contasFinanceiras.value = [];
    contasFinanceirasLoaded.value = false;

};

//==================================================================//
//========================== Limpa Modal ===========================//
//==================================================================//

const limpaModal = ()=>{

    preparaDado();
    preparaAdiantamento();
    limpaContaFinanceira();

};

//==================================================================//
//=========================== Abre Modal ===========================//
//==================================================================//

const abreModal = async ()=>{

    // Bloqueia a Tela, Inicia o Loading no Botão
    alteraModalLoading(true);

    // Prepara e Busca os Dados
    preparaDado(UtilObject.clone(props.dadoOriginal));
    preparaAdiantamento();
    await loadContasFinanceiras();

    // Desbloqueia a Tela, Finaliza o Loading no Botão
    alteraModalLoading(false);

};

//==================================================================//
//====================== Watch => modalStatus ======================//
//==================================================================//

watch(()=> props.modalStatus, async () => {

    if(props.modalStatus == false){

        limpaModal();

    }else if(modalVisivel.value == false){

        await abreModal();

    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="modalVisivel"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :modalStatus="props.modalStatus"
                    :controlesDesativados="props?.controlesDesativados"
                    :dado="dado"
                    :adiantamento="adiantamento"
                    @update:alteraRecarregaDados="alteraRecarregaDados"
                    @update:alteraModalStatus="alteraModalStatus"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                ></BarraNavegacao>

                <DadoConteudo
                    :controlesDesativados="props.controlesDesativados"
                    :modalStatus="props.modalStatus"
                    :contasFinanceiras="contasFinanceiras"
                    :dado="dado"
                    :adiantamento="adiantamento"
                    @update:alteraAdiantamento="alteraAdiantamento"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

